import apis from '../apis/index'
import cloudApi from '../apis/cloudStorageApi'
import Vue from 'vue'
import { Toast } from 'mint-ui'

export function downLoadFile (downType, fileId, isdir, vId, name) {
  Vue.prototype.$customStore.dispatch('getPermissionBtns').then(() => {
    if (!Vue.prototype.$customFunctions.checkPermission('download')) {
      Toast({
        message: '您没有权限进行此操作!',
        duration: 3000,
        iconClass: 'icon-error'
      })
    } else {
      doDownLoadFile(downType, fileId, isdir, vId, name)
    }
  })
}

export function doDownLoadFile (downType, fileId, isdir, vId, name) {
  var downloadId = downType
  var hasDir = isdir
  // 用于存储请求下载的文件id
  var ids = ''
  // 请求链接
  var url = ''
  if (!downloadId) {
    return false
  }
  if (downloadId === '1') {
    // 文件
    ids = fileId
  } else if (downloadId === '2') {
    // 历史版本
    ids = vId
  }
  // 没有选择需要下载的文件
  if (!ids) {
    return false
  }
  if (downloadId === '1') {
    if (ids.indexOf(',') > -1) {
      url = apis.app.cloudStorage.baseUrl + cloudApi.multifilesD.path + '?fileIds=' + ids
    } else {
      if (hasDir === 0) {
        url = apis.app.cloudStorage.baseUrl + cloudApi.unifileD.path + '?fileId=' + ids
      } else {
        url = apis.app.cloudStorage.baseUrl + cloudApi.multifilesD.path + '?fileIds=' + ids
      }
    }
  } else if (downloadId === '2') {
    url = apis.app.cloudStorage.baseUrl + cloudApi.versionUnifileD.path + '?vid=' + ids
  }

  if (!url) {
    return false
  }
  var eleLink = document.createElement('a')
  eleLink.style.display = 'none'
  eleLink.href = url
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}



// WEBPACK FOOTER //
// ./src/components/download.js